const buildQuery = (params = {}) => {
  const query = new URLSearchParams();

  if (params.page) query.append('page', String(params.page));
  if (params.limit) query.append('limit', String(params.limit));
  if (params.search) query.append('search', params.search);
  if (params.tag) query.append('tag', params.tag);
  if (params.year) query.append('year', String(params.year));
  if (params.month) query.append('month', String(params.month));

  return query.toString();
};

export const fetchLogbookEntries = async (params = {}) => {
  const query = buildQuery(params);
  const response = await fetch(`/api/logbook${query ? `?${query}` : ''}`);

  if (!response.ok) {
    throw new Error('Errore nel recupero del logbook');
  }

  return response.json();
};

export const fetchLogbookEntryBySlug = async (slug) => {
  const response = await fetch(`/api/logbook/${encodeURIComponent(slug)}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('not-found');
    }
    throw new Error('Errore nel recupero del dettaglio logbook');
  }

  return response.json();
};

export const fetchLogbookComments = async (slug) => {
  const response = await fetch(
    `/api/logbook/${encodeURIComponent(slug)}/comments`
  );
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('not-found');
    }
    throw new Error('Errore nel recupero dei commenti');
  }
  return response.json();
};

export const createLogbookComment = async ({
  slug,
  memberId,
  content,
  parentId = null,
}) => {
  const response = await fetch(
    `/api/logbook/${encodeURIComponent(slug)}/comments`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        memberId,
        content,
        parentId,
      }),
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload?.message || 'Errore nella creazione del commento');
  }

  return response.json();
};

export const deleteLogbookComment = async ({ slug, commentId }) => {
  const response = await fetch(
    `/api/logbook/${encodeURIComponent(slug)}/comments/${encodeURIComponent(commentId)}`,
    {
      method: 'DELETE',
      credentials: 'include',
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(
      payload?.message || 'Errore nella cancellazione del commento'
    );
  }

  return response.json();
};
